import { Onboarding } from '../pages/Onboarding';
import { landingAnchorRoutes } from './landingAnchorRoutes';
import { NewsDetailPage } from '../pages/NewsDetail';
import { Information } from '../pages/Information';
import { Registration } from '../pages/Registration';
import { Landing as LandingNew } from '../pages/LandingNew';


export const routes = {
    home: {
        route: '/',
        page: LandingNew,
        anchors: landingAnchorRoutes,
    },
    onboarding: {
        route: '/onboarding',
        name: 'Регистрация',
        page: Onboarding,
        isRed: true,
    },
    newsdetail: {
        route: '/news/:id',
        name: 'Новость',
        page: NewsDetailPage,
    },
    registration: {
        route: '/registration',
        name: 'Регистрация',
        page: Registration,
    },
    information: {
        route: '/information',
        name: 'Раскрытие информации',
        page: Information,
    },
};

export const headerRoutes = [
    'investors',
    'registration',
    'documents',
];

export const footerRoutes = [[], [], [], []];
